const LoginUserSvg = ({
  width = 13,
  height = 14,
  viewBox = '0 0 13 14',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M3.41699 9.25H8.75C9.32464 9.25 9.8759 9.47844 10.2822 9.88477C10.6885 10.2911 10.917 10.8424 10.917 11.417V12.25H1.25V11.417C1.25 10.8424 1.47844 10.2911 1.88477 9.88477C2.29109 9.47844 2.84236 9.25 3.41699 9.25ZM6.08301 1.25C6.74605 1.25 7.38272 1.51358 7.85156 1.98242C8.3202 2.45123 8.58301 3.08711 8.58301 3.75C8.58301 4.41289 8.3202 5.04877 7.85156 5.51758C7.38272 5.98642 6.74605 6.25 6.08301 6.25C5.42008 6.24991 4.78419 5.98634 4.31543 5.51758C3.84669 5.04875 3.58301 4.41296 3.58301 3.75C3.58301 3.08704 3.84669 2.45125 4.31543 1.98242C4.78419 1.51366 5.42008 1.25009 6.08301 1.25Z"
        stroke="currentColor"
      />
      <path
        d="M9.08333 3.75C9.08333 4.54565 8.76726 5.30871 8.20465 5.87132C7.64204 6.43393 6.87898 6.75 6.08333 6.75C5.28768 6.75 4.52462 6.43393 3.96201 5.87132C3.3994 5.30871 3.08333 4.54565 3.08333 3.75C3.08333 2.95435 3.3994 2.19129 3.96201 1.62868C4.52462 1.06607 5.28768 0.75 6.08333 0.75C6.87898 0.75 7.64204 1.06607 8.20465 1.62868C8.76726 2.19129 9.08333 2.95435 9.08333 3.75ZM11.4167 12.75V11.4167C11.4167 10.7094 11.1357 10.0311 10.6356 9.53105C10.1355 9.03095 9.45724 8.75 8.75 8.75H3.41667C2.70942 8.75 2.03115 9.03095 1.53105 9.53105C1.03095 10.0311 0.75 10.7094 0.75 11.4167V12.75H11.4167Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
};
export default LoginUserSvg;
